<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/terminalAuthorizationList' }">终端授权</el-breadcrumb-item>
                <el-breadcrumb-item>终端授权{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="submitApproval('submitForm')" :loading="btnLoading">保存并提交</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                        :is_init="fieldTypeMap[item.prop]['is_init']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'terminalAuthorizationEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
            if (key == 'province_rid') {
                this.$refs.city_rid_ref[0].request_params.parent_rid = value;
                this.$refs.city_rid_ref[0].initData();
            }
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                representative_rid: {
                    request_uri: 'dropdownPartners',
                    title: '合作方',
                    ref: 'representative_rid_ref',
                    type: 'dropdown',
                    is_init: true
                },
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    is_init: true,
                    request_params: { type_code: [11, 91] }
                },
                province_rid: {
                    request_uri: 'provinces',
                    title: '省份',
                    ref: 'province_rid_ref',
                    type: 'dropdown',
                    is_init: true
                },
                city_rid: {
                    request_uri: 'cities',
                    title: '城市',
                    ref: 'city_rid_ref',
                    type: 'dropdown',
                    is_init: false,
                    request_params: {}
                },
                business_rid: {
                    request_uri: 'searchAccounts',
                    title: '一级商业',
                    ref: 'business_rid_ref',
                    default_option_key: 'business_option',
                    type: 'search_select'
                },
                terminal_rid: {
                    request_uri: 'searchAccounts',
                    title: '终端',
                    ref: 'terminal_rid_ref',
                    default_option_key: 'terminal_option',
                    type: 'search_select'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                }
            };
        },
        initFormRule() {
            this.rules = {
                unit_marginal_expense_quota: [{ required: true, message: '单位限额必填', trigger: 'blur' }],
                bid_price: [{ required: true, message: '中标价必填', trigger: 'blur' }],
                unit_invoice_price: [{ required: true, message: '发票单价必填', trigger: 'blur' }],
                business_point: [{ required: true, message: '配送点数必填', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                // province_rid: [{ required: true, message: '请选择省份', trigger: 'blur' }],
                // city_rid: [{ required: true, message: '请选择城市', trigger: 'blur' }],
                // terminal_rid: [{ required: true, message: '请输入终端搜索', trigger: 'blur' }],
                representative_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                start_date: [{ required: true, message: '请选择开始日期', trigger: 'blur' }],
                // end_date: [{ required: true, message: '请选择结束日期', trigger: 'blur' }],
                business_rid: [{ required: true, message: '请输入一级商业搜索', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id || '';
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                business_rid: this.data.business_rid || '',
                terminal_rid: this.data.terminal_rid || '',
                product_rid: this.data.product_rid || '',
                province_rid: this.data.province_rid || '',
                city_rid: this.data.city_rid || '',
                unit_marginal_expense_quota: this.data.unit_marginal_expense_quota || '0',
                bid_price: this.data.bid_price || '0',
                unit_invoice_price: this.data.unit_invoice_price || '0',
                business_point: this.data.business_point || '0',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                representative_rid: this.data.representative_rid || '',
                business_option: { rid: this.data.business_rid || '', name: this.data.business || '' },
                terminal_option: { rid: this.data.terminal_rid || '', name: this.data.terminal || '' }
            };

            if (this.formData.city_rid != '') {
                this.$refs.city_rid_ref[0].request_params.parent_rid = this.formData.province_rid;
                this.$refs.city_rid_ref[0].initData();
            }
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('dataList')).terminal_authorization;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['unit_marginal_expense_quota', 'start_date', 'end_date', 'bid_price', 'unit_invoice_price', 'business_point']
                },
                {
                    business: 'business_rid',
                    terminal: 'terminal_rid',
                    product: 'product_rid',
                    province_name: 'province_rid',
                    city_name: 'city_rid',
                    representative: 'representative_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/terminalAuthorizationList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .terminalAuthorizationDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        // 保存
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.formData.approval_status = 1; // 草稿
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        // 保存并提交
        submitApproval(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.formData.approval_status = 2; // 审核中
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'terminalAuthorizationUpdate';
            } else {
                uri = 'terminalAuthorizationInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>